import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function SubelementoDespesaModal({ show, onClose, onSave, data }) {
  const [idElemento, setIdElemento] = useState('');
  const [codigo, setCodigo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [elementos, setElementos] = useState([]);
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (show) {
      axios.get(API_BASE_URL.ELEMENTO_DESPESA, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setElementos(Array.isArray(res.data) ? res.data : []))
        .catch(() => {});

      if (data) {
        setIdElemento(data.idElemento || '');
        setCodigo(data.codigo || '');
        setDescricao(data.descricao || '');
      } else {
        setIdElemento('');
        setCodigo('');
        setDescricao('');
      }
    }
  }, [data, show, token]);

  const handleSave = async () => {
    if (!idElemento || !codigo || !descricao) return;
    setSaving(true);
    try {
      const payload = { idElemento, codigo, descricao };
      if (data) {
        await axios.put(`${API_BASE_URL.SUBELEMENTO_DESPESA}/${data.idElemento}/${data.codigo}`, payload, { headers: { Authorization: `Bearer ${token}` } });
      } else {
        await axios.post(API_BASE_URL.SUBELEMENTO_DESPESA, payload, { headers: { Authorization: `Bearer ${token}` } });
      }
      if (onSave) onSave();
      if (onClose) onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header text-white" style={{ background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)', padding: '0.5rem 1rem' }}>
            <h6 className="modal-title mb-0">{data ? 'Editar Subelemento de Despesa' : 'Novo Subelemento de Despesa'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={saving} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">Elemento de Despesa</label>
              <select className="form-select" value={idElemento}
                onChange={e => setIdElemento(e.target.value)} disabled={!!data}>
                <option value="">Selecione...</option>
                {elementos.map(el => (
                  <option key={el.codigo} value={el.codigo}>{el.codigo} - {el.descricao}</option>
                ))}
              </select>
            </div>
            <div className="mb-2">
              <label className="form-label">Código</label>
              <input type="text" className="form-control" maxLength={2} value={codigo}
                onChange={e => setCodigo(e.target.value)} disabled={!!data} />
            </div>
            <div className="mb-2">
              <label className="form-label">Descrição</label>
              <textarea className="form-control" rows={4} value={descricao} onChange={e => setDescricao(e.target.value)} />
            </div>
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-secondary me-2" onClick={onClose} disabled={saving}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving || !idElemento || !codigo || !descricao}>
              {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubelementoDespesaModal;
